import {createStore} from 'vuex';
import offices from "./offices";
import specialists from "./specialists";
import services from "./services";
import categories from "./categories";
import news from "./news"
import venousServices from "@/store/venousServices";
import utils from "@/store/utils";
import aboutUsModals from "@/store/aboutUsModals";
import fullCare from "@/store/fullCare";
import homePopUpModal from "@/store/homePopUpModal";


export default createStore({
    modules: {
        offices,
        specialists,
        services,
        categories,
        news,
        venousServices,
        utils,
        aboutUsModals,
        fullCare,
        homePopUpModal
    },
});
